module.exports = __webpack_public_path__ + "img/top-bar.144211c1.png";